
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playzone",
      function () {
        return require("private-next-pages/playzone/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playzone"])
      });
    }
  